import Backbone from 'backbone';
import _ from 'lodash';

import OrderTypes from '@/enums/OrderTypes';

import OrderDevicesView from '../views/OrderDevicesView/OrderDevicesView';
import GetAllOrderFormDataByOrderId from '../services/GetAllOrderFormDataByOrderId';
import GetAllMFDCustomerOrderFormDataByOrderId from '../services/GetAllMFDCustomerOrderFormDataByOrderId';
import GetDeviceMatrixByFormId from '../services/GetDeviceMatrixByFormId';
import GetOFMFDRelocationByOrderId from '../services/GetOFMFDRelocationByOrderId';
import GetOrderLineItemsByVersionAndOrderID from '../services/GetOrderLineItemsByVersionAndOrderID'

export default async function loadOrderDevicesView(orderDetails) {
  let itemsService;
  if (orderDetails.orderTypeId === OrderTypes.MFD || orderDetails.orderTypeId === OrderTypes.JAPAN) {
    itemsService = GetAllMFDCustomerOrderFormDataByOrderId;
  } else if (orderDetails.orderTypeId === OrderTypes.RELOCATION) {
    itemsService = GetOFMFDRelocationByOrderId;
  } else {
    itemsService = GetAllOrderFormDataByOrderId;
  }

  const [lineItems, orderItems, deviceMatrix] = await Promise.all([
    GetOrderLineItemsByVersionAndOrderID(orderDetails.orderId),
    itemsService(orderDetails.orderId),
    GetDeviceMatrixByFormId(orderDetails.orderTypeId)
  ]);
  const formData = {};

  // Map
  switch (orderDetails.orderTypeId) {
    case '1':
    case '3':
      _.forEach(orderItems, (item) => {
        if (item.isColor === '0') {
          item.isColor = 'Mono (B&W)';
        }
        if (item.isColor === '1') {
          item.isColor = 'Color';
        }
        if (item.isNipr === '1') {
          item.isNipr = 'NIPR';
        }
        if (item.isNipr === '0') {
          item.isNipr = 'SIPR';
        }
      });
      break;
    case '2':
    case '4':
    case '5':
    case '6':
    case '10':
    case '11':
    case '13':
    case '14':
    case '15':
    case '16':
    case '17':
    case '18':
    case '20':
    case '21':
    case '22':
    case '23':
    case '24':
    case '25':
    case '26':
      _.forEach(lineItems, (item) => {
        const orderItem = _.find(orderItems, ['orderLineItemId', item.id]);
        item.quantity = orderItem?.quantity || '0';
        item.totalPrice = orderItem?.quantity * orderItem?.price || 0;
      });
      break;
    case '12':
      break;
  }

  return new OrderDevicesView({
    model: new Backbone.Model({
      orderDetails,
      lineItems,
      orderItems,
      formData,
      deviceMatrix
    })
  });
}
